import styled from 'styled-components';

export default styled.p`
	color: ${(p) => {
		if (p.color === 'blue') {
			return p.theme.color.blue;
		} else if (p.color === 'red') {
			return p.theme.color.red;
		} else if (p.color === 'green') {
			return p.theme.color.green;
		} else if (p.color === 'light') {
			return p.theme.color.light;
		} else {
			return p.theme.color.dark;
		}
	}};
	font-weight: 700;
	margin-bottom: 1rem;
	font-size: 0.9rem;
	line-height: 1.1rem;
`;
